webpackJsonp([189730916535050],{

/***/ 828:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"title":"Remembering Bunji Tagawa","createdAt":"a day ago","by":"yaseen-rob","comments":[]}}

/***/ })

});


// WEBPACK FOOTER //
// path---comment-17765351-3e97e035da224349aef1.js